import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["items"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import i18n from "@Shared/@i18n";
import { isEmpty, orderBy, kebabCase } from "lodash";
import { MONTHS_NAMES } from "@Shared/utils/constants";
import { snakeUppercase } from "@Shared/@Utils/utils";
import { getSubstitutionsNamesInfo, setCustomFieldsValues } from "@Broker/js/utils/store-helpers/client-profile";
export const REFERRER_LINKED_APPLICATIONS = "REFERRER_LINKED_APPLICATIONS";
export const REFERRER_LINKED_PROFILES = "REFERRER_LINKED_PROFILES";
export const LABEL_LINKED_PROFILES = "LABEL_LINKED_PROFILES";
export const FILTER_REFERRER_TIMELINE_LIST = "FILTER_REFERRER_TIMELINE_LIST";
export const REFERRER_CUSTOM_FIELDS_DEFINITIONS = "REFERRER_CUSTOM_FIELDS_DEFINITIONS";
export const REFERRER_CUSTOM_FIELDS_TAGS = "REFERRER_CUSTOM_FIELDS_TAGS";
export const REFERRER_CUSTOM_FIELDS_HINT_TAGS = "REFERRER_CUSTOM_FIELDS_HINT_TAGS";
export const REFERRER_TIMELINE_ITEM = "REFERRER_TIMELINE_ITEM";
export const REFERRERS = "REFERRERS";
export const RAW_REFERRERS = "RAW_REFERRERS";
export const REFERRERS_COUNT = "REFERRERS_COUNT";
export const REFERRERS_LOADED = "REFERRERS_LOADED";
export const GET_CURRENT_FILTERS = "GET_CURRENT_FILTERS";
export const GET_CURRENT_REFERRERS = "GET_CURRENT_REFERRERS";
const getters = {
  referrersCustomFieldsDefinitions: state => {
    var _state$referrersCusto;
    return (_state$referrersCusto = state.referrersCustomFieldsDefinitions) != null ? _state$referrersCusto : {};
  },
  referrerCustomFields: state => id => {
    var _state$referrers$byId;
    return ((_state$referrers$byId = state.referrers.byId[id]) == null ? void 0 : _state$referrers$byId.customFields) || [];
  },
  [REFERRER_LINKED_APPLICATIONS]: state => referrerId => {
    return state.referrersLinkedApplications.byId[referrerId] || [];
  },
  [REFERRER_LINKED_PROFILES]: state => referrerId => {
    return state.referrersLinkedProfiles.byId[referrerId] || [];
  },
  [LABEL_LINKED_PROFILES]: state => label => {
    return state.linkedProfilesLabelTranslationMap[label] || label;
  },
  [REFERRER_CUSTOM_FIELDS_DEFINITIONS]: state => () => {
    var _state$referrersCusto2;
    return (_state$referrersCusto2 = state.referrersCustomFieldsDefinitions) != null ? _state$referrersCusto2 : {};
  },
  [REFERRERS_LOADED]: state => {
    return state.referrers.allIds.length;
  },
  [REFERRERS_COUNT]: state => {
    return state.totalReferrers;
  },
  [RAW_REFERRERS]: state => {
    return state.rawReferrers;
  },
  [GET_CURRENT_FILTERS]: state => {
    return state.referrerFilters;
  },
  [GET_CURRENT_REFERRERS]: state => {
    var _context;
    return _mapInstanceProperty(_context = state.referrers.allIds).call(_context, id => state.referrers.byId[id]);
  },
  [FILTER_REFERRER_TIMELINE_LIST]: (state, getters) => ({
    id,
    filter
  }) => {
    const timeline = getters.getTimeline(id);
    if (filter === "pinned") {
      return _filterInstanceProperty(timeline).call(timeline, ({
        sectionKey
      }) => sectionKey === "pinned");
    }
    return _mapInstanceProperty(timeline).call(timeline, _ref => {
      let {
          items
        } = _ref,
        monthTimeline = _objectWithoutProperties(_ref, _excluded);
      return _objectSpread(_objectSpread({}, monthTimeline), {}, {
        items: _filterInstanceProperty(items).call(items, t => {
          if (filter === "automation") {
            return t.automationType;
          }
          return filter === "all" || t.activityType === filter;
        })
      });
    });
  },
  getTimeline: state => id => {
    var _state$referrers$byId2, _state$referrers$byId3, _context3, _context4;
    if (!((_state$referrers$byId2 = state.referrers.byId[id]) != null && (_state$referrers$byId3 = _state$referrers$byId2.timeline) != null && _state$referrers$byId3.length)) return [];
    const PINNABLE_TABS = ["follow-up", "note", "checklist"];
    const PINNED_INDEX = 0;
    const SCHEDULED_INDEX = 1;
    const {
      timeline
    } = state.referrers.byId[id];
    const sectionIndexes = {};
    const dripCampaignsIds = {};
    const parsedTimeline = _reduceInstanceProperty(timeline).call(timeline, (parsedTimeline, timelineItem, _, unparsed) => {
      const {
        activityType,
        createdAt,
        updatedAt,
        complete,
        pinned,
        automationType,
        campaignId
      } = timelineItem;
      if (activityType === "follow-up" && !complete) {
        parsedTimeline[SCHEDULED_INDEX].items.push(timelineItem);
      } else {
        var _context2;
        const timestampUTC = _includesInstanceProperty(_context2 = ["account-creation", "file", "email", "event"]).call(_context2, activityType) ? createdAt : updatedAt;
        const dateObject = new Date(timestampUTC);
        const month = `${MONTHS_NAMES()[dateObject.getMonth()]} ${dateObject.getFullYear()}`;
        const timestamp = dateObject.getTime();
        const index = sectionIndexes[month];
        const itemToAdd = [timelineItem];
        const isDrip = automationType === "drip-campaign";
        const shouldDuplicateDrip = isDrip && !dripCampaignsIds[campaignId];
        if (shouldDuplicateDrip) {
          const stages = _reduceInstanceProperty(unparsed).call(unparsed, (acc, item) => {
            if (item.automationType === "drip-campaign" && item.campaignId === campaignId) {
              acc.push(_parseInt(item.stageId));
            }
            return acc;
          }, []);
          const firstStage = Math.min(...stages);
          const itemToPush = _findInstanceProperty(unparsed).call(unparsed, ({
            stageId
          }) => _parseInt(stageId) === firstStage);
          itemToAdd.unshift(_objectSpread(_objectSpread({}, itemToPush), {}, {
            addition: true,
            sent: undefined,
            activityType: "drip-campaign-creation"
          }));
          dripCampaignsIds[campaignId] = true;
        }
        if (index >= 0) {
          parsedTimeline[index].items.push(...itemToAdd);
        } else {
          parsedTimeline.push({
            sectionName: month,
            items: [...itemToAdd],
            timestamp
          });
          sectionIndexes[month] = parsedTimeline.length - 1;
        }
      }
      if (pinned && _includesInstanceProperty(PINNABLE_TABS).call(PINNABLE_TABS, activityType)) {
        parsedTimeline[PINNED_INDEX].items.push(timelineItem);
      }
      return parsedTimeline;
    }, [{
      sectionKey: "pinned",
      sectionName: i18n.t("client-profile.pinned"),
      items: [],
      timestamp: 0
    }, {
      sectionKey: "scheduled",
      sectionName: i18n.t("client-profile.scheduled"),
      items: [],
      timestamp: 0
    }]);
    const parsedWithEmailThreads = _mapInstanceProperty(_context3 = _sortInstanceProperty(_context4 = _mapInstanceProperty(parsedTimeline).call(parsedTimeline, monthTimeline => {
      var _context5;
      monthTimeline.items = _reduceInstanceProperty(_context5 = monthTimeline.items).call(_context5, (parsedByMonth, activity) => {
        if (activity.activityType === "email") {
          var _context6, _context7;
          const {
            createdAt,
            updatedAt,
            threadId,
            activityType,
            from
          } = activity;
          const splittedFrom = from.split("<");
          activity.fromName = _trimInstanceProperty(_context6 = splittedFrom[0] || "").call(_context6);
          activity.fromEmail = _trimInstanceProperty(_context7 = splittedFrom[1] || splittedFrom[0] || "").call(_context7).replace(">", "");
          const threadIndex = _findIndexInstanceProperty(parsedByMonth).call(parsedByMonth, thread => activity.threadId && thread.threadId === activity.threadId);
          if (threadIndex >= 0) {
            parsedByMonth[threadIndex].threadEmails.push(activity);
          } else {
            parsedByMonth.push({
              activityType,
              threadId,
              threadEmails: [activity],
              createdAt,
              updatedAt
            });
          }
        } else {
          parsedByMonth.push(activity);
        }
        return parsedByMonth;
      }, []);
      return monthTimeline;
    })).call(_context4, ({
      sectionKey: sectionKeyA,
      timestamp: timestampA
    }, {
      sectionKey: sectionKeyB,
      timestamp: timestampB
    }) => {
      if (sectionKeyA === "pinned") return -1;
      if (sectionKeyB === "pinned") return 1;
      if (sectionKeyA === "scheduled") return -1;
      if (sectionKeyB === "scheduled") return 1;
      return timestampB - timestampA;
    })).call(_context3, monthTimeline => {
      var _context8;
      const timestamps = {
        automation: "updatedAt",
        note: "updatedAt",
        checklist: "updatedAt",
        "follow-up": "updatedAt",
        "client-application-request": "updatedAt"
      };
      const filteredItems = _filterInstanceProperty(_context8 = monthTimeline.items).call(_context8, ({
        sent,
        deleted
      }) => typeof sent === "undefined" || sent || deleted);
      const items = orderBy(filteredItems, [function (activity) {
        return activity[timestamps[activity.activityType] || "createdAt"];
      }, "addition"], ["desc", "desc"]);
      return _objectSpread(_objectSpread({}, monthTimeline), {}, {
        items
      });
    });
    const scheduled = parsedWithEmailThreads[1].items;
    if (!isEmpty(scheduled)) {
      parsedWithEmailThreads[1].items = orderBy(scheduled, "scheduledDate", "asc");
    }
    return parsedWithEmailThreads;
  },
  getReferrerChangeLog: state => id => {
    const {
      changelog
    } = state.referrers.byId[id];
    if (!changelog) return [];
    const changelogWithoutUnknown = _filterInstanceProperty(changelog).call(changelog, c => c.type !== "unknown" || c.field !== "unknown");
    const changelogWithMonth = _reduceInstanceProperty(changelogWithoutUnknown).call(changelogWithoutUnknown, (acc, curr) => {
      const dateObject = new Date(curr.insertionTimestamp);
      const month = `${MONTHS_NAMES()[dateObject.getMonth()]} ${dateObject.getFullYear()}`;
      if (acc[month]) {
        acc[month].items.push(curr);
      } else {
        acc[month] = {
          sectionName: month,
          sectionKey: kebabCase(month),
          timestamp: curr.insertionTimestamp,
          items: [curr]
        };
      }
      return acc;
    }, {});
    return orderBy(_Object$values(changelogWithMonth), ["timestamp"], ["desc"]);
  },
  [REFERRER_CUSTOM_FIELDS_TAGS]: (state, getters) => referrerId => {
    var _context9;
    return _mapInstanceProperty(_context9 = getters.referrerCustomFields(referrerId)).call(_context9, ({
      name,
      type
    }) => {
      return {
        name: snakeUppercase(name),
        type
      };
    });
  },
  [REFERRER_CUSTOM_FIELDS_HINT_TAGS]: (state, getters) => referrerId => {
    var _context0;
    return _mapInstanceProperty(_context0 = getters.referrerCustomFields(referrerId)).call(_context0, ({
      name
    }) => snakeUppercase(name));
  },
  getDetailsForSubstitution: (state, getters) => id => {
    const referrerDetails = state.referrers.byId[id] || {};
    const substitutionsNamesInfo = getSubstitutionsNamesInfo(referrerDetails);
    const customFieldDefinitions = getters.REFERRER_CUSTOM_FIELDS_DEFINITIONS();
    if (isEmpty(customFieldDefinitions)) return [];
    const customFields = getters.referrerCustomFields(id);
    return [...substitutionsNamesInfo, ...setCustomFieldsValues(customFields, customFieldDefinitions)];
  },
  [REFERRER_TIMELINE_ITEM]: state => (referrerId, timelineItemType, timelineItemId) => {
    var _context1;
    return _findInstanceProperty(_context1 = state.referrers.byId[referrerId].timeline).call(_context1, item => item.activityType === timelineItemType && item.id == timelineItemId);
  },
  [REFERRERS]: state => {
    return _Object$values(state.referrers.byId);
  }
};
export default getters;